// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { LawType, Maybe } from '../../../../../generated'
import { CaseContext } from '../../../../context'
import { FinalBillsContext } from '../../../../context/FinalBillsContext'

const LawTypeFilter: FC = () => {
  const { allLawTypes } = useContext(CaseContext)
  const { filters, setFilters } = useContext(FinalBillsContext)
  const selectedLawType = allLawTypes?.find(lawType => lawType?.id === filters.lawTypeId) || null

  const handleLawTypeChange = (value: Maybe<LawType>) => {
    setFilters({ lawTypeId: value?.id })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 150 }}
      options={allLawTypes || []}
      value={selectedLawType}
      onChange={(_, value) => handleLawTypeChange(value)}
      getOptionLabel={option => option?.name || ''}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={params => <TextField {...params} label="Law Type" />}
    />
  )
}

export default LawTypeFilter
